import mp3 from '../../assets/mp3s'

// Songs are now just in a single mp3.
export const getMp3 = () => mp3
